import React from "react";

const DevelopmentProcessCore = ({ timelineData }) => {
  return (
    <div>
      <div className="  bg-light">
        <div className="timeline-container container">
          <div className="timeline-line"></div>
          {timelineData.map((item, index) => {
            const isEven = index % 2 === 0;
            const contentOnRight = isEven;
            return (
              <div
                style={{
                  flexDirection: contentOnRight ? "row" : "row-reverse",
                }}
                className={`timeline-item ${item.icon ? "timeline-boxs" : ""}`}
                key={index}
              >
                {/* Heading Side */}
                <div className={`timeline-side `}>
                  <div className={`timeline-box heading-box   `}>
                    <h3  className="h3-heading  " style={{ width: "max-content" }}>
                      {item.heading}
                    </h3>
                  </div>
                </div>

                {/* Dot */}
                <div className="timeline-dot" />

                {/* Content Side */}
                <div className="timeline-side">
                  <div
                    className={`timeline-box content-box ${
                      contentOnRight ? "arrow-left" : "arrow-right"
                    }`}
                  >
                    <p className="h3-para">{item.content}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DevelopmentProcessCore;
